const AuthenticationType = {
    1: "Hash",
    2: "LDAP",
    3: "LDAPSmart",
    4: "SSO",
}

export default AuthenticationType;
